import { AvailableBnplLimitOfferStateEnum } from '.spec/self-care/tsTypes';

import { MyProfile } from '@skippay/core/@types/myProfile';

type AvailableBnplLimits = MyProfile['options']['availableBnplLimits'] | undefined;

export type BnplLimitOfferStates = {
	isProcessing: boolean;
	canApply: boolean;
};

export const getBnplLimitOfferStates = (
	availableBnplLimits: AvailableBnplLimits
): BnplLimitOfferStates => {
	const limitOfferStates = [
		availableBnplLimits?.deferredPayment?.limitOfferState,
		availableBnplLimits?.payInThree?.limitOfferState,
	];

	return {
		isProcessing: limitOfferStates.includes(AvailableBnplLimitOfferStateEnum.PROCESSING),
		canApply: limitOfferStates.includes(AvailableBnplLimitOfferStateEnum.CAN_APPLY),
	};
};

export const isBnplLimitAvailable = (
	profile: MyProfile,
	productType: 'deferredPayment' | 'payInThree'
): boolean => {
	return (
		profile.options?.availableBnplLimits?.[productType]?.limitOfferState ===
		AvailableBnplLimitOfferStateEnum.CAN_APPLY
	);
};
